<script setup lang="ts">
/**
 * SG Incorporation (Post) — 문서 [[Signers]] 자리.
 * L_ENTITY 가 있으므로 SignersField 에 entityCd 를 넘겨 Director 등 officer 선택 가능.
 */
import { computed } from 'vue';
import SignersField from '@/features/startTask/preset_task/my/preset/components/resignation/signers/SignersField.vue';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';
import { useSgPostSigners } from './sgPostSignersContext';

const props = withDefaults(
  defineProps<{ varKey: string; boardLabel?: string }>(),
  { boardLabel: '' },
);

const ctx = useSgPostSigners();
const signers = computed(() => ctx.signersOf(props.varKey));
const entityCd = computed(() => String(ctx.entityCd.value || '').trim());

function onUpdate(list: SignerEntry[]) {
  ctx.setSigners(props.varKey, list);
}
</script>

<template>
  <SignersField
    :model-value="signers"
    :board-label="boardLabel"
    :var-key="varKey"
    :entity-cd="entityCd"
    @update:model-value="onUpdate"
  />
</template>
